<template>
  <div class="service_filter">
    <p class="service_filter_label" v-translate>Služba upravuje:</p>
    <p class="service_filter_item">
      <filter-checkbox
          id="pvr"
          name="pvrfilter"
          v-model="filters.pvr">
        <translate class="translate">PVR</translate>
      </filter-checkbox>
    </p>
    <p class="service_filter_item">
      <filter-checkbox
          id="periodicPvr"
          name="periodicPvrfilter"
          v-model="filters.periodicPvr">
        <translate class="translate">Periodické nahrávky</translate>
      </filter-checkbox>
    </p>
    <p class="service_filter_item">
      <filter-checkbox
          id="catchup"
          name="catchupfilter"
          v-model="filters.catchup">
        <translate class="translate">Catchup</translate>
      </filter-checkbox>
    </p>
    <p class="service_filter_item">
      <filter-checkbox
        id="timeshift"
        name="timeshiftfilter"
        v-model="filters.timeshift">
        <translate class="translate">Timeshift</translate>
    </filter-checkbox>
    </p>
    <p class="service_filter_item">
      <filter-checkbox
          id="advertisements"
          name="advertisementsfilter"
          v-model="filters.advertisements">
        <translate class="translate">Reklamy</translate>
      </filter-checkbox>
    </p>
    <p class="service_filter_item">
      <filter-checkbox
          id="devices"
          name="devicesfilter"
          v-model="filters.devices">
        <translate class="translate">Zařízení</translate>
      </filter-checkbox>
    </p>
    <p class="service_filter_item">
      <filter-checkbox
          id="profiles"
          name="profilesfilter"
          v-model="filters.profiles">
        <translate class="translate">Uživatelské profily</translate>
      </filter-checkbox>
    </p>
    <p class="service_filter_item">
      <filter-checkbox
          id="vod"
          name="vodfilter"
          v-model="filters.vod">
        <translate class="translate">Videotéka</translate>
      </filter-checkbox>
    </p>
    <p class="service_filter_item">
      <filter-checkbox
          id="channels"
          name="channelsfilter"
          v-model="filters.channels">
        <translate class="translate">Kanály</translate>
      </filter-checkbox>
    </p>
    <p class="show_all_services" v-if="showPackButton && !isAllUnpacked"><a @click.prevent.stop="unpackAll()" v-translate>Rozbalit vše</a></p>
    <p class="show_all_services" v-if="showPackButton && isAllUnpacked"><a @click.prevent.stop="packAll()" v-translate>Sbalit vše</a></p>
  </div>
</template>

<script >
export default {
  name: "ServiceFilterByProperty",
  props:{
    showPackButton: Boolean,
    isAllUnpacked: Boolean,
    value: Object,
  },
  data(){
    return {
      filters: this.value
    }
  },
  methods:{
    unpackAll(){
      this.$emit('unpackAll');
    },
    packAll(){
      this.$emit('packAll');
    },
  },
  watch:{
    filters:{
      handler() {
        this.$emit('input', this.filters);
      },
      deep: true
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/views/subscribers/servicesList/ServiceFilterByProperty.vue